<div class="dialog-header">
    <h2>Reject {{ data.contractName }}</h2>
    <ng-icon name="heroXMark" mat-dialog-close class="cursor-pointer"></ng-icon>
</div>
<form [formGroup]="rejectForm" (ngSubmit)="reject()">
    <mat-dialog-content>
        Please mention the rejection reason:
        <div class="w-100 reject-form">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Reject Reason</mat-label>
                <textarea matInput formControlName="rejectReason" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="3" cdkAutosizeMaxRows="8" [errorStateMatcher]="matcher"></textarea>
                <mat-error *ngIf="rejectForm.get('rejectReason').hasError('required')">
                    Reject Reason is required
                </mat-error>
            </mat-form-field>
        </div>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <mat-dialog-actions align="end">
        <button mat-raised-button mat-dialog-close color="primary" mat-dialog-close
            class="outlined-btn">Cancel</button>
        <button color="accent" mat-raised-button class="ml-3" [disabled]="isLoading" type="submit">Submit
            <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
        </button>
    </mat-dialog-actions>
</form>